const ENDPOINT = "https://auto-exclusive-api.labo-linkibe.fr";

export default ENDPOINT;